[
  {
    "code": "LR-BM",
    "name": "Bomi"
  },
  {
    "code": "LR-BG",
    "name": "Bong"
  },
  {
    "code": "LR-GP",
    "name": "Gbarpolu"
  },
  {
    "code": "LR-GB",
    "name": "Grand Bassa"
  },
  {
    "code": "LR-CM",
    "name": "Grand Cape Mount"
  },
  {
    "code": "LR-GG",
    "name": "Grand Gedeh"
  },
  {
    "code": "LR-GK",
    "name": "Grand Kru"
  },
  {
    "code": "LR-LO",
    "name": "Lofa"
  },
  {
    "code": "LR-MG",
    "name": "Margibi"
  },
  {
    "code": "LR-MY",
    "name": "Maryland"
  },
  {
    "code": "LR-MO",
    "name": "Montserrado"
  },
  {
    "code": "LR-NI",
    "name": "Nimba"
  },
  {
    "code": "LR-RG",
    "name": "River Gee"
  },
  {
    "code": "LR-RI",
    "name": "Rivercess"
  },
  {
    "code": "LR-SI",
    "name": "Sinoe"
  }
]